<app-nav></app-nav>
<section class="refer-article" *ngIf="articleInfoSection">
  <div class="container">
    <img
      src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/Refer/Articles/articles-banner.png" />
    <h5 class="head">Refer an article to 3 or more friends & earn upto <span>500</span> Wallet points* on valid referrals</h5>
    <div class="refer-btm">
      <h5>How it works?</h5>
      <ul>
        <li><div class="circle">1</div> Refer an article to 3 or more friends</li>
        <li><div class="circle">2</div> Get 250 points when friends sign-up</li>
        <li><div class="circle">3</div> Redeem wallet points & get an Amazon voucher</li>
      </ul>
      <p>*1point = ₹1</p>
    </div>
    <!-- <div class="refer-text">
      <img
        src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/Refer/Articles/man-with-question-mark.png" />
      <div class="refer-con">
        <h6>What you have to do</h6>
        <div class="todoList">
          <label>Refer articles to 3 friends</label>
          <label>Friends sign up to read</label>
          <label>You get a voucher for spreading knowledge</label>
        </div>
      </div>
      <div class="clearfix"></div>
    </div> -->
    <button class="btn btn-orange mt-4 btn-padding"
      (click)="articleListSection = true; articleInfoSection = false;">Refer Article</button>
  </div>
</section>
<section class="refer-form-section" *ngIf="articleListSection">
  <div class="article-list" *ngFor="let data of articleData">
    <div class="article-heading d-flex">
      <h5 routerLink="/articles-detail/{{data._id}}">{{data.articleTitle}}</h5>
      <button class="share-icon ml-auto" (click)="openModal(template);"></button>
    </div>
    <div class="main-image" routerLink="/articles-detail/{{data._id}}">
      <img
        src="{{data.imageUrl}}"
        width="100%" />
    </div>
    <p class="summary" [innerHTML] = "(data.articleContent.length>200)? (data.articleContent | slice:0:100)+'..':(data.articleContent)"></p>
    <div class="bottom-section">
      <div class="block-left">
        <span class="claimant-icon"><img src="{{data.articleSource}}"></span>
        <span class="published-date">Published on {{data.created | date}}</span>
      </div>
      <div class="like-section">
        <button class="like-btn" (click)="likeArticle(data._id);"><img
            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/Refer/Articles/thumsup-oval.svg"></button>
        <span class="like-count">{{data.totalLikeCount}}</span>
      </div>
    </div>
    <ng-template #template>
        <form name="form" (ngSubmit)="f.form.valid" #f="ngForm">
        <div class="modal-header">
          <h4>Share</h4>
          <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" id="shareModal">
          <div class="col">
            <h4 class="modal-title">Share details of your friend</h4>
          </div>
          <div class="col sum-container">
            <p class="title mt-4 mendatory">Name</p>
            <div class="sum-insured-input">
              <div class="form-group">
                <input type="text" class="form-control" name="name" id="name" placeholder="Name" #name="ngModel" [(ngModel)]="f.name" pattern="[a-zA-Z\s]+" maxlength="100" required>
              </div>
            </div>
            <div *ngIf="name.invalid && name.touched " class="error-message">
              <div *ngIf="name.errors.required">
                Name is required.
              </div>
              <div *ngIf="name.errors.pattern">
                Please enter the valid Name.
              </div>
            </div>
          </div>
          <div class="col sum-container">
            <p class="title mt-4 mendatory">Mobile No.</p>
            <div class="sum-insured-input">
              <div class="form-group">
                <input type="text" #mobile="ngModel" name="mobile" id="mobile" placeholder="Mobile No." class="form-control"
                (keydown.space)="$event.preventDefault();" minlength="10" maxlength="10"
                [(ngModel)]="f.mobile" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric" required>
              </div>
            </div>
            <div *ngIf="mobile.invalid && mobile.touched " class="error-message">
              <div *ngIf="mobile.errors.required">
                Mobile number is required.
              </div>
              <div *ngIf="mobile.errors.minlength && !mobile.errors.pattern">
                Mobile number must be at least 10 digits long.
              </div>
              <div *ngIf="(!mobile.errors.minlength || mobile.errors.pattern) && !mobile.errors.required">
                Invalid mobile number.
              </div>
            </div>
          </div>
          <div class="col sum-container">
            <p class="title mt-4 mendatory">E-mail</p>
            <div class="sum-insured-input">
              <div class="form-group">
                <input type="text" class="form-control" name="email" id="email" placeholder="E-mail address" #email="ngModel" [(ngModel)]="f.email" maxlength="100" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$" required>
              </div>
            </div>
            <div *ngIf="email.invalid && email.touched " class="error-message">
              <div *ngIf="email.errors.required">
                Email  address is required.
              </div>
              <div *ngIf="email.errors.pattern">
                Email must be a valid email address
              </div>
            </div>
          </div>
          <div class="col sum-container">
            <p class="title mt-4 mendatory">City</p>
            <input type="text" class="form-control" placeholder="City" [typeahead]="cityList"
            (typeaheadOnSelect)="selectCity($event)" (focusout)="checkCityValue($event)" maxlength="100" [isAnimated]="true" #location="ngModel" name="location"
              [(ngModel)]="f.location" required />
            <div *ngIf="location.invalid && location.touched " class="error-message">
              <div *ngIf="location.errors.required && !noResult">
                City is required.
              </div>
            </div>
            <div *ngIf="noResult" class="error-message">No results found!</div>
          </div>
          <div class="col text-center mt-4">
            <button class="btn btn-bordered-blue" aria-label="Close" (click)="shareArticle(data.linkedToproductType,f,data._id)"
            [disabled]="f.form.invalid || noResult" (click)="modalRef.hide()">Next</button>
          </div>
        </div>
        </form>
      </ng-template>
  </div>
</section>
<span id="snackbar"></span>
<div id="spinner" [hidden]="!loading">
  <div class="spinnerfull">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
</div>